import isDefined from "../../Core/isDefined";
import UrlMixin from "../../ModelMixins/UrlMixin";
/**
 * The terriajs-server is the default server that proxies a URL associated with a catalog item, if necessary.
 * @param {CatalogItem} [catalogItem] The catalog item.
 * @param {string} url The URL to be proxied.
 * @param {string} [cacheDuration] The cache duration to use if catalogItem.cacheDuration is undefined.
 * @returns {string} The URL, now cached if necessary.
 */
export default function proxyCatalogItemUrl(catalogItem, url, cacheDuration) {
  var _catalogItem$terria;
  const corsProxy = catalogItem === null || catalogItem === void 0 || (_catalogItem$terria = catalogItem.terria) === null || _catalogItem$terria === void 0 ? void 0 : _catalogItem$terria.corsProxy;
  if (isDefined(corsProxy) && (corsProxy.shouldUseProxy(url) || UrlMixin.isMixedInto(catalogItem) && catalogItem.forceProxy)) {
    var _ref;
    cacheDuration = (_ref = UrlMixin.isMixedInto(catalogItem) ? catalogItem.cacheDuration : undefined) !== null && _ref !== void 0 ? _ref : cacheDuration;
    return corsProxy.getURL(url, cacheDuration);
  } else {
    return url;
  }
}

/**
 * Similar to {@link proxyCatalogItemUrl}, but only returns proxy base url, not full URL (for example `proxy/`, instead of `proxy/some/other/resource`)
 */
export function proxyCatalogItemBaseUrl(catalogItem, url, cacheDuration) {
  var _catalogItem$terria2;
  const corsProxy = catalogItem === null || catalogItem === void 0 || (_catalogItem$terria2 = catalogItem.terria) === null || _catalogItem$terria2 === void 0 ? void 0 : _catalogItem$terria2.corsProxy;
  if (isDefined(corsProxy) && (corsProxy.shouldUseProxy(url) || UrlMixin.isMixedInto(catalogItem) && catalogItem.forceProxy)) {
    var _ref2;
    cacheDuration = (_ref2 = UrlMixin.isMixedInto(catalogItem) ? catalogItem.cacheDuration : undefined) !== null && _ref2 !== void 0 ? _ref2 : cacheDuration;
    return corsProxy.getProxyBaseURL(cacheDuration);
  }
}